<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>工单管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a>华屹库存变化记录</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section>
      <section class="searchBox">
        <span>
          <label>操作日期：</label>
          <a-range-picker
            v-model="date"
            :ranges="{
              今天: [moment(), moment()],
              本月: [moment().startOf('month'), moment()],
              上月: [
                moment()
                  .month(moment().month() - 1)
                  .startOf('month'),
                moment()
                  .month(moment().month() - 1)
                  .endOf('month')
              ]
            }"
            @change="selectedDate"
          />
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            placeholder="请输入网点设备名称|商品名称"
            style="width:300px"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.device_name }}</td>
              <td>{{ item.action_time }}</td>
              <td>{{ item.select_date }}</td>
              <td>{{ item.slot }}</td>
              <td>{{ item.brand_name }}</td>
              <td><img :src="item.imageUrl.url_thumb" alt="" /></td>
              <td>{{ item.real_quantity }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      moment,
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "网点名称",
        "操作日期",
        "拉取日期",
        "货道",
        "商品名称",
        "图片",
        "数量"
      ],
      query_field: "",
      start_date: "",
      end_date: "",
      date: null
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {},
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    selectedDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.date = null;
      this.start_date = "";
      this.end_date = "";
      this.query_field = "";
      this.page = 1;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Device_slot/lists";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        end_date: this.end_date,
        start_date: this.start_date,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  td {
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
}
</style>
